module.exports = __webpack_public_path__ + "img/4.d2c1d4de.png";